var each = require('./each');
    //basic mixin function, copy over object properties to provided object
    module.exports = function(destination,source){
        each(source,function(val,key){
            destination[key] = val;
        });
        return destination;
    };




//////////////////
// WEBPACK FOOTER
// ./node_modules/toxiclibsjs/internals/mixin.js
// module id = 4577
// module chunks = 15